require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./drug-treatment-court-for-women-with-children.json") })
        }
      }, "path---drug-treatment-court-for-women-with-children");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---drug-treatment-court-for-women-with-children!./.cache/json/drug-treatment-court-for-women-with-children.json
// module id = 881
// module chunks = 231608221292675